export const tabBarProps = {
	screenOptions: {
		headerShown: false,
	}
}

export const tabBarScreenProps = {
	options: {
		gestureDirection: 'horizontal',
	}
}

export const stackProps = {
	screenOptions: {
		headerShown: false,
	}
}

export const stackScreenProps = {
	options: {
		animation: 'slide_from_right',
	}
}
